import { ApiOrg } from 'api/types/ApiOrg';
import { ApiUnpublishedOrg } from 'api/types/ApiUnpublishedOrg';
import { OrgDashboardApiGradProgram } from 'modules/orgDashboard/api/types/OrgDashboardApiGradProgram';
import { OrgDashboardApiOrg } from 'modules/orgDashboard/api/types/OrgDashboardApiOrg';
import { getJson, postJson } from 'utils/http';

export function apiCreateOrg(
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  orgInfo: Record<string, any>,
): Promise<OrgDashboardApiOrg> {
  return postJson(`/data/website/organizations`, orgInfo).then(
    // @ts-expect-error TS(2345): Argument of type '({ org }: { org: any; }) => any'... Remove this comment to see the full error message
    ({ org }) => org,
  );
}

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function apiValidateOrg(payload: Record<string, any>): Promise<{
  Org: ApiOrg;
}> {
  return postJson(`/data/website/organizations-validation`, payload);
}

export function apiCreateOrgWithGradProgram(
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  info: Record<string, any>,
): Promise<{
  org: OrgDashboardApiOrg;
  gradProgram: OrgDashboardApiGradProgram;
}> {
  return postJson('/data/website/organizations-with-grad-program', info);
}

export function apiFetchOrg(
  orgId: string,
): Promise<ApiOrg | ApiUnpublishedOrg> {
  return getJson(`/data/website/organizations/${orgId}`).then(
    // @ts-expect-error TS(2345): Argument of type '({ data, org }: { data: any; org... Remove this comment to see the full error message
    ({ data, org }) => data || org,
  );
}

export function apiOrgRequestAdmin(orgId: string, requestTo: string) {
  return postJson(`/data/website/organizations/${orgId}/request-admin`, {
    requestTo,
  });
}
